import React from 'react';
import styled from '@emotion/styled';
import { cx } from '@emotion/css';
import { parseHtml } from '../helpers';

type Props = {
  title: string;
  strapline?: string;
  className?: string;
};

const Heading = styled.h2({
  fontFamily: 'var(--font-heading)',

  '&.A': {
    color: 'var(--color-secondary)',
  },
});

export const TilesHeader: React.FC<Props> = ({ className, title, strapline }) => {
  return (
    <div data-testid='mp-tiles-header'>
      <Heading className={cx(className, 'display-4-light')} data-testid='mp-tiles-header-title'>
        {title}
      </Heading>
      {strapline ? (
        <p className='strapline' data-testid='mp-tiles-header-strapline'>
          {parseHtml(strapline)}
        </p>
      ) : null}
    </div>
  );
};
